import { appAbandonToken } from '@actions/app.action';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { Store } from '@ngrx/store';
import { CollapseModule } from 'ngx-bootstrap/collapse';

@Component({
  selector: 'app-header-menu-user',
  standalone: true,
  imports: [CommonModule, CollapseModule, SvgIconComponent],
  templateUrl: './header-menu-user.component.html',
  styleUrl: './header-menu-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMenuUserComponent {
  @Input() username?: string;
  @Input() logoutLabel?: string;
  @Input() yourAccountNameLabel?: string;
  @Input() yourAccountLink?: string;
  @Input() withArrow?: boolean = true;
  @Input() className?: string;

  collapsed = true;

  private router = inject(Router);
  private store = inject(Store);

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }

  setCollapsed(collapsed: boolean) {
    this.collapsed = collapsed;
  }

  logOut(): void {
    this.setCollapsed(true);
    this.store.dispatch(appAbandonToken());
  }

  goTo(url?: string): void {
    if (url) {
      this.setCollapsed(true);
      this.router.navigate([url]);
    }
  }
}
